* {
  box-sizing: border-box;
}

:host {
  display: block;
  --descripion-height: 105px;
}

gz-card {
  margin-right: 0;
  margin-bottom: 0;
}

.wrapper {
  padding: 2px;
  display: inline-flex;

  .card-description {
    font-size: var(--body-size);
    max-height: var(--descripion-height);
    min-height: var(--descripion-height);
    font-family: var(--font-family-secondary);
  }

  .card-integration-type {
    font-size: 12px;
    font-style: italic;
    margin-bottom: var(--spacer);
  }

  .card-license-active {
    margin-top: var(--spacer);

    gz-title {
      margin-bottom: calc(var(--spacer) * 2);
    }

    .card-license-active-wrapper {
      display: flex;
      flex-direction: row;
      align-items: end;

      .labeled-content-container {
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-right: calc(var(--spacer) * 3);

        gz-labeled-content {
          --label-width-percentage: 25%;
          --value-width-percentage: 75%;
          height: 16px;
          margin-bottom: var(--spacer);

          &::part(label) {
            font-size: var(--body-size);
          }
          &::part(content) {
            font-size: var(--body-size);
            font-weight: 500;
            color: var(--body-text-arrows-400);
            --font-family: var(--font-family-secondary);
          }
        }
      }
    }
  }
  .card-license-not-active {
    .card-license-not-active-wrraper {
      display: flex;
      flex-direction: column;
      margin-top: var(--spacer);

      .cell-label {
        font-size: var(--body-size-large);
        font-family: var(--font-family-secondary);
      }

      gz-button {
        margin-top: calc(var(--spacer) * 4);
      }
    }
  }
  gz-info-box {
    &::part(container) {
      margin: calc(var(--spacer) * 3 + 3px) 0 0 0;
      padding: calc(var(--spacer) - 4px) var(--spacer);
    }
  }
}
